import { useRef, useState } from "react";
import { useSnapshot } from "valtio";
import { editapprovalStore } from "../quote-approval/editapprovalStore";
import { dataListStore } from "../state/CommonState";
import Utils from "../util/Utils";
import TenantUtils from "../util/tenant.utils";
import { useMobile } from "../hooks/usemobile";

export default function CopyMail(props) {
  let setOpenCopyMail = props.setOpenCopyMail;
  const [copied, setCopied] = useState(false);
  const [copied1, setCopied1] = useState(false);
  const [view, setView] = useState("Detailed");
  const [showView, setShowView] = useState(false);
  const isMobile = useMobile();
  useSnapshot(editapprovalStore);
  const copyRef = useRef(null);
  const copyRef1 = useRef(null);
  useSnapshot(dataListStore);
  const prjs = (d) => {
    return JSON.parse(JSON.stringify(d));
  };
  const Card = ({ rec, copiedOceanFreight, id }) => {
    let origin = rec.quoteData.origin;
    let destination = rec.quoteData.destination;
    let pod = rec.quoteData.portOfDischarge;
    let fpod = rec.quoteData.finalPlaceOfDelivery;
    let rep = rec.quoteData.reworkingPort;
    let shipmentType = rec.quoteData.shipmentType;
    let validtill = Utils.ddmmyyyy(
      new Date(rec.quoteData.validUpto),
    );
    let VesselName = "";
    let VoyageNumber = "";
    let ETDDate = "";
    let agentAddress = "";
    let agentDetails = "";
    let carrier = "";
    let transitTime = 0;
    let schedules = [];
    let tc = [];
    if (rec.quoteData.tc != undefined) {
      tc = rec.quoteData.tc;
    }
    // if(rec.quote.terms!=undefined){
    //     let t = rec.quote.terms
    //     if(t['your']!=undefined){
    //         tc = tc.concat(t['your'])
    //     }
    //     if(t['consignee']!=undefined){
    //         tc = tc.concat(t['consignee'])
    //     }
    //     if(t['shipper']!=undefined){
    //         tc = tc.concat(t['shipper'])
    //     }
    // }
    if (rec.quoteData.customTerms != undefined) {
      tc = tc.concat(rec.quoteData.customTerms);
    }
    // if(schedules.length>0){
    //     let s = schedules[0]
    //     if(s['VESSEL NAME']!=undefined){
    //         VesselName = s['VESSEL NAME']
    //     }
    //     if(s['VOYAGE']!=undefined){
    //         VoyageNumber = s['VOYAGE']
    //     }
    //     if(s['ETD (POL)']!=undefined){
    //         ETDDate = s['ETD (POL)']
    //     }
    // }
    let chargelist = [];
    console.log("+++++++++++++++++++++++++++++++++9000000000",chargelist)
    chargelist = chargelist.concat(rec.chargesList);
    console.log("+++++++++++++++++++++++++++++++++9000000000",chargelist)
    chargelist = chargelist.concat(
      rec.consigneechargesList,
    );
    chargelist = chargelist.concat(rec.shipperchargesList);
    console.log("+++++++++++++++++++++++++++++++++9000000000",chargelist)
    let perchargelable = "";
    let Ocean_Freight_amount = 0;
    let Ocean_Freight_currency = "USD";
    for (let i = 0; i < chargelist.length; i++) {
        if (chargelist[i]!=undefined && chargelist[i]["chargeDescription"] == "Ocean Freight") {
          let k = Object.keys(chargelist[i]);
          for (let j = 0; j < k.length; j++) {
            if (k[j].indexOf("perWM") != -1) {
              perchargelable = k[j].split("perWM")[0];
              Ocean_Freight_amount = chargelist[i][k[j]];
              Ocean_Freight_currency = chargelist[i]["currency"];
              j = k.length + 1;
            }
          }
        }
      }
    const getRouting = (ReWorkingPortName, POD, FPOD) => {
      const routing =
        ReWorkingPortName != undefined && ReWorkingPortName.length > 0
          ? ReWorkingPortName
          : POD;
      if (routing !== FPOD) {
        return `${routing}`;
      } else {
        return `Direct`;
      }
    };
    let routing = getRouting(rep, pod, fpod);
    const convertCharges = (charges) => {
      return charges.map((item) => {
        const curr = item.currency;
        const cbm = item.perCBM || 0;
        const ton = item.perTon || 0;
        const min = item.minimum || 0;
        const max = item.maximum || 0;
        const perBL = item.perShipment || 0;

        let CH = "";
        let displayLogic = "";

        const hasCBM = cbm != 0;
        const hasTon = ton != 0;
        const cbmEqualsTon = hasCBM && hasTon && cbm === ton;

        // ---------------------------------------------------------
        // IDENTIFY CHARGE HEAD (CH1–CH7)
        // ---------------------------------------------------------
        if (perBL != 0 && min === 0 && max != 0 && !hasCBM && !hasTon) {
          CH = "CH9"; // Per Bill of Lading With Maximum
        } else if (perBL != 0 && min != 0 && max === 0 && !hasCBM && !hasTon) {
          CH = "CH8"; // Per Bill of Lading With Minimum
        } else if (perBL != 0 && min === 0 && max === 0 && !hasCBM && !hasTon) {
          CH = "CH7"; // Per Bill of Lading
        } else if (hasCBM && hasTon && min === 0 && max === 0) {
          CH = "CH1"; // Basic W/M logic
        } else if (hasCBM && !hasTon) {
          CH = "CH2"; // Per CBM only
        } else if (!hasCBM && hasTon) {
          CH = "CH3"; // Per Ton only
        } else if (hasCBM && hasTon && min > 0 && max === 0) {
          CH = "CH4"; // With Minimum
        } else if (hasCBM && hasTon && min != 0 && max != 0) {
          CH = "CH5"; // With Min + Max
        } else if (hasCBM && hasTon && min === 0 && max != 0) {
          CH = "CH6"; // With Maximum
        } else {
          CH = "CH1"; // Default fallback
        }

        // ----------------------------
        // CBM / TON DISPLAY PART
        // ----------------------------

        let wmLogic = "";

        if (hasCBM || hasTon) {
          if (cbmEqualsTon) {
            wmLogic = `${Utils.N(cbm, curr)} Per W/M`;
          } else if (hasCBM && hasTon) {
            wmLogic = `${Utils.N(cbm, curr)} Per CBM OR ${Utils.N(ton, curr)} Per Ton`;
          } else if (hasCBM) {
            wmLogic = `${Utils.N(cbm, curr)} Per CBM`;
          } else {
            wmLogic = `${Utils.N(ton, curr)} Per Ton`;
          }
        }

        // ---------------------------------------------------------
        // DISPLAY LOGIC BASED ON CH RULES
        // ---------------------------------------------------------

        switch (CH) {
          // ------------------- CH1 -------------------
          // ------------------- CH2 -------------------
          // ------------------- CH3 -------------------
          case "CH1":
          case "CH2":
          case "CH3":
            displayLogic = wmLogic;
            if (perBL !== 0) {
              displayLogic += `, ${Utils.N(perBL, curr)} Per Bill of Lading`;
            }
            break;

          // ------------------- CH4 -------------------
          case "CH4":
            displayLogic = `${wmLogic}, Minimum ${Utils.N(min, curr)}`;
            break;

          // ------------------- CH5 -------------------
          case "CH5":
            displayLogic = `${wmLogic}, Minimum ${Utils.N(min, curr)} AND Maximum ${Utils.N(max, curr)}`;
            break;

          // ------------------- CH6 -------------------
          case "CH6":
            displayLogic = `${wmLogic}, Maximum ${Utils.N(max, curr)}`;
            break;

          // ------------------- CH7 -------------------
          case "CH7":
            displayLogic = `${Utils.N(perBL, curr)} Per Bill of Lading`;
            if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
            break;
          // ------------------- CH8 -------------------
          case "CH8":
            displayLogic = `${Utils.N(min, curr)} Minimum, ${Utils.N(perBL, curr)} Per Bill of Lading`;
            if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
            break;
          // ------------------- CH9 -------------------
          case "CH9":
            displayLogic = `${Utils.N(max, curr)} Maximum, ${Utils.N(perBL, curr)} Per Bill of Lading`;
            if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
            break;
        }
        if(displayLogic.indexOf('Per Bill of Lading')==-1){
            if(perBL != 0){
                displayLogic += `, ${Utils.N(perBL, curr)} Per Bill of Lading`;
            }
        }

        return {
          chargeDescription: item.chargeDescription,
          CH,
          currency: curr,
          perCBM: cbm || null,
          perTon: ton || null,
          minimum: min || null,
          maximum: max || null,
          perBL: perBL || null,
          displayLogic,
        };
      });
    };
    let origincharges = [];
    let oceanFreightcharges = [];
    let Destinationcharges = [];
    let DestinationDescription = [];
    for (let i = 0; i < chargelist.length; i++) {
      let c = chargelist[i];
      if (c != undefined && c["chargeDescription"] != undefined) {
        let d = c["chargeDescription"];
        let cat = (c["category"] || "").toUpperCase();

        if (cat === "ORIGIN") {
          d = d.replace("Origin Charges - ", "");
          d = d.replace("Origin - ", "");
          d = d.replace("Origin Charges", "");
          d = d.replace("Origin", "");
          chargelist[i]["chargeDescription"] = d;
          origincharges.push(chargelist[i]);
        } else if (cat === "DESTINATION") {
          d = d.replace("Destination Charges - ", "");
          d = d.replace("Destination - ", "");
          d = d.replace("Destination Charges", "");
          d = d.replace("Destination", "");
          chargelist[i]["chargeDescription"] = d;
          if (d.length > 0) {
            DestinationDescription.push(d);
          }
          Destinationcharges.push(chargelist[i]);
        } else if (cat === "FREIGHT" || cat === "OCEAN FREIGHT") {
          oceanFreightcharges.push(chargelist[i]);
        }
      }
    }
    let Destinationchargestotal = {
      chargeDescription: "Destination",
      perCBM: 0,
      perTon: 0,
      minimum: 0,
      maximum: 0,
      perBL: 0,
      currency: "INR",
    };
    
      for (let i = 0; i < Destinationcharges.length; i++) {
        let d = Destinationcharges[i];
        Destinationchargestotal["currency"] = Destinationcharges[0]["currency"];
        let k = ["perCBM", "perTon", "minimum", "maximum", "perBL"];
        k.map((e) => {
          if (d[e] != undefined && d[e]) {
            Destinationchargestotal[e] =
              Destinationchargestotal[e] + Number(d[e]);
          }
        });
      }

      origincharges = convertCharges(origincharges);
      oceanFreightcharges = convertCharges(oceanFreightcharges);
      if (Destinationcharges.length > 0) {
        Destinationchargestotal = convertCharges([Destinationchargestotal]);
        Destinationcharges = convertCharges(Destinationcharges);
      }
    
    return (
      <>
        <div
          id={id}
          key={id}
          style={
            copiedOceanFreight
              ? {
                  position: "absolute",
                  left: "-9999px",
                  top: 0,
                  width: "800px",
                }
              : {}
          }
        >
          <div
            ref={!copiedOceanFreight ? copyRef : copyRef1}
            style={{
              backgroundColor: "#fff",
              borderRadius: ".25rem",
              boxShadow:
                "0 .5em 1em -.125em rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .02)",
              color: "#4a4a4a",
              maxWidth: "100%",
              position: "relative",
              padding: "15px",
            }}
          >
            <p>
              <strong>Origin</strong> : {origin}
            </p>
            <p>
              <strong>Destination</strong> : {destination}
            </p>
            <p>
              <strong>Routing</strong> : {routing}
            </p>
            {shipmentType.indexOf("FCL") != -1 && (
              <p>
                <strong>Valid Till</strong> : {validtill}
              </p>
            )}
            {shipmentType.indexOf("FCL") != -1 && carrier.length > 0 && (
              <p>
                <strong>Carrier</strong> : {carrier}
              </p>
            )}
            {shipmentType.indexOf("FCL") != -1 && transitTime > 0 && (
              <p>
                <strong>Ocean Transit Time</strong> : {transitTime}
              </p>
            )}
            {shipmentType.indexOf("FCL") != -1 && (
              <p>
                <strong>Ocean Freight (Per Container):</strong> :{" "}
                {Utils.N(Ocean_Freight_amount, Ocean_Freight_currency)} per{" "}
                {perchargelable}
              </p>
            )}
            {/* <p><strong>Vessel Name</strong> : {VesselName.length>0?VesselName:""}</p>
    <p><strong>Voyage Number</strong> : {VoyageNumber.length>0?VoyageNumber:""}</p>
    <p><strong>ETD Date</strong> : {ETDDate.length>0?ETDDate:""}</p> */}
            {showView && (
              <div className="columns is-vcentered is-multiline">
                <div className="column is-12" style={{ textAlign: "left" }}>
                  <div
                    className="field is-grouped"
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <div className="control">
                      <button
                        className="button"
                        style={{
                          backgroundColor:
                            view == "Summary"
                              ? "#48c78e"
                              : process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                          color: "#fff",
                        }}
                        onClick={async (e) => {
                          if (view != "Summary") {
                            setView("Summary");
                          }
                        }}
                      >
                        Summary
                      </button>
                    </div>
                    <div className="control">
                      <button
                        className="button"
                        style={{
                          backgroundColor:
                            view == "Detailed"
                              ? "#48c78e"
                              : process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                          color: "#fff",
                        }}
                        onClick={async (e) => {
                          if (view != "Detailed") {
                            setView("Detailed");
                          }
                        }}
                      >
                        Detailed
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {oceanFreightcharges.length > 0 && (
              <>
                <p>
                  <strong>
                    <u>Ocean Freight</u>
                  </strong>
                </p>
                <div className="table-container">
                  <table className="table" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th>Charge Description</th>
                        <th>Charges</th>
                        {/* <th>Remarks</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {oceanFreightcharges.map((e) => {
                        return (
                          <tr>
                            <td>{e.chargeDescription}</td>
                            <td>{e.displayLogic}</td>
                            {/* <td>{e.remarks}</td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            )}
            {!copiedOceanFreight && origincharges.length > 0 && (
              <>
                <p>
                  <strong>
                    <u>Origin Charges</u>
                  </strong>
                </p>
                <div className="table-container">
                  <table className="table" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th>Charge Description</th>
                        <th>Charges</th>
                        {/* <th>Remarks</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {origincharges.map((e) => {
                        return (
                          <tr>
                            <td>{e.chargeDescription}</td>
                            <td>{e.displayLogic}</td>
                            {/* <td>{e.remarks}</td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            )}
            {view == "Detailed" && (
              <>
                {!copiedOceanFreight && Destinationcharges.length > 0 && (
                  <>
                    <p>
                      <strong>
                        <u>Destination Charges</u>
                      </strong>
                    </p>
                    <div className="table-container">
                      <table className="table" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>Charge Description</th>
                            <th>Charges</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Destinationcharges.map((e) => {
                            return (
                              <tr>
                                <td>{e.chargeDescription}</td>
                                <td>{e.displayLogic}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </>
            )}
            {view == "Summary" && (
              <>
                {!copiedOceanFreight && Destinationcharges.length > 0 && (
                  <>
                    <p>
                      <strong>
                        <u>Destination Charges - Summary</u>
                      </strong>
                    </p>
                    <p>
                      <strong>Destination Charges Total</strong> :{" "}
                      {Destinationchargestotal[0].displayLogic}
                    </p>
                    {DestinationDescription.length > 0 && (
                      <>{"Inclusive of " + DestinationDescription.join(", ")}</>
                    )}
                  </>
                )}
              </>
            )}
            {(agentDetails.length > 0 || agentAddress.length > 0) && (
              <p>
                <strong>
                  <u>Agent Details</u>
                </strong>
              </p>
            )}
            {agentDetails.length > 0 && (
              <p>
                <strong>Agent Name</strong> : {agentDetails}
              </p>
            )}
            {agentAddress.length > 0 && (
              <p>
                <strong>Agent Contact</strong> : {agentAddress}
              </p>
            )}
            {/* <p><strong><u>Carting address</u></strong></p>
    <p><strong>JWR Logistics Pvt.Ltd</strong></p>
    <p>Shed No C , Point G,H,I 8,</p>
<p>National highway 4B, Panvel-JNPT highway, Village Padeghar, Panvel, Maharashtra 410206</p>
<p>Navexel representative Sumit Mali +91-8976802450 , Raghunath Pawar +91-9323498013, Tushar Gaikwad : +91-9702830081</p> */}
            {!copiedOceanFreight && tc.length > 0 && (
              <>
                <p>
                  <strong>
                    <u>Terms & Conditions</u>
                  </strong>
                </p>
                <ul>
                  {tc.map((e, i) => {
                    return (
                      <li key={i}>
  {i + 1}. {typeof e === "object" ? e.term : e}
</li>
                    );
                  })}
                </ul>
              </>
            )}
            {copiedOceanFreight && (
              <>
                <p>
                  <strong>
                    <u>Terms & Conditions</u>
                  </strong>
                </p>
                <ul>
                  <li>Destination Charges are at Actual.</li>
                  <li>Destination CFS Charges are at actuals.</li>
                </ul>
              </>
            )}
          </div>
        </div>
      </>
    );
  };

  const copyTextToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (err) {
        console.error("Clipboard API failed: ", err);
      }
    }
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      textArea.remove();
      return true;
    } catch (err) {
      console.error("Fallback copy failed: ", err);
      textArea.remove();
      return false;
    }
  };

  const buildMobileCopyTextForRateRequest = (quoteRec, copiedOceanFreight, viewMode = "Detailed") => {
    let rec = quoteRec;
    if (!rec || !rec.quoteData) return "";

    let origin = rec.quoteData.origin || "";
    let destination = rec.quoteData.destination || "";
    let pod = rec.quoteData.portOfDischarge;
    let fpod = rec.quoteData.finalPlaceOfDelivery;
    let rep = rec.quoteData.reworkingPort;
    let shipmentType = rec.quoteData.shipmentType || "";
    let validtill = rec.quoteData.validUpto ? Utils.ddmmyyyy(new Date(rec.quoteData.validUpto)) : "";
    let agentAddress = "";
    let agentDetails = "";
    let tc = [];

    if (rec.quoteData.tc != undefined) {
      tc = rec.quoteData.tc;
    }
    if (rec.quoteData.customTerms != undefined) {
      tc = tc.concat(rec.quoteData.customTerms);
    }
    if (rec.quoteData.agentAddress != undefined) {
      agentAddress = TenantUtils.changeagent ? TenantUtils.changeagent(rec.quoteData.agentAddress) : rec.quoteData.agentAddress;
    }
    if (rec.quoteData.agentDetails != undefined) {
      agentDetails = TenantUtils.changeagent ? TenantUtils.changeagent(rec.quoteData.agentDetails) : rec.quoteData.agentDetails;
    }

    let chargelist = [];
    if (rec.chargesList) chargelist = chargelist.concat(rec.chargesList);
    if (rec.consigneechargesList) chargelist = chargelist.concat(rec.consigneechargesList);
    if (rec.shipperchargesList) chargelist = chargelist.concat(rec.shipperchargesList);

    let perchargelable = "";
    let Ocean_Freight_amount = 0;
    let Ocean_Freight_currency = "USD";
    for (let i = 0; i < chargelist.length; i++) {
      if (chargelist[i] != undefined && chargelist[i]["chargeDescription"] == "Ocean Freight") {
        let k = Object.keys(chargelist[i]);
        for (let j = 0; j < k.length; j++) {
          if (k[j].indexOf("perWM") != -1) {
            perchargelable = k[j].split("perWM")[0];
            Ocean_Freight_amount = chargelist[i][k[j]];
            Ocean_Freight_currency = chargelist[i]["currency"];
            break;
          }
        }
      }
    }

    const getRouting = (ReWorkingPortName, POD, FPOD) => {
      const routing = ReWorkingPortName != undefined && ReWorkingPortName.length > 0 ? ReWorkingPortName : POD;
      if (routing !== FPOD) {
        return `${routing}`;
      } else {
        return `Direct`;
      }
    };
    let routing = getRouting(rep, pod, fpod);

    const convertCharges = (charges) => {
      return charges.map((item) => {
        const curr = item.currency;
        const cbm = item.perCBM || 0;
        const ton = item.perTon || 0;
        const min = item.minimum || 0;
        const max = item.maximum || 0;
        const perBL = item.perShipment || 0;

        let CH = "";
        let displayLogic = "";

        const hasCBM = cbm != 0;
        const hasTon = ton != 0;
        const cbmEqualsTon = hasCBM && hasTon && cbm === ton;

        if (perBL != 0 && min === 0 && max != 0 && !hasCBM && !hasTon) {
          CH = "CH9";
        } else if (perBL != 0 && min != 0 && max === 0 && !hasCBM && !hasTon) {
          CH = "CH8";
        } else if (perBL != 0 && min === 0 && max === 0 && !hasCBM && !hasTon) {
          CH = "CH7";
        } else if (hasCBM && hasTon && min === 0 && max === 0) {
          CH = "CH1";
        } else if (hasCBM && !hasTon) {
          CH = "CH2";
        } else if (!hasCBM && hasTon) {
          CH = "CH3";
        } else if (hasCBM && hasTon && min > 0 && max === 0) {
          CH = "CH4";
        } else if (hasCBM && hasTon && min != 0 && max != 0) {
          CH = "CH5";
        } else if (hasCBM && hasTon && min === 0 && max != 0) {
          CH = "CH6";
        } else {
          CH = "CH1";
        }

        let wmLogic = "";
        if (hasCBM || hasTon) {
          if (cbmEqualsTon) {
            wmLogic = `${Utils.N(cbm, curr)} Per W/M`;
          } else if (hasCBM && hasTon) {
            wmLogic = `${Utils.N(cbm, curr)} Per CBM OR ${Utils.N(ton, curr)} Per Ton`;
          } else if (hasCBM) {
            wmLogic = `${Utils.N(cbm, curr)} Per CBM`;
          } else {
            wmLogic = `${Utils.N(ton, curr)} Per Ton`;
          }
        }

        switch (CH) {
          case "CH1":
          case "CH2":
          case "CH3":
            displayLogic = wmLogic;
            if (perBL !== 0) {
              displayLogic += `, ${Utils.N(perBL, curr)} Per Bill of Lading`;
            }
            break;
          case "CH4":
            displayLogic = `${wmLogic}, Minimum ${Utils.N(min, curr)}`;
            break;
          case "CH5":
            displayLogic = `${wmLogic}, Minimum ${Utils.N(min, curr)} AND Maximum ${Utils.N(max, curr)}`;
            break;
          case "CH6":
            displayLogic = `${wmLogic}, Maximum ${Utils.N(max, curr)}`;
            break;
          case "CH7":
            displayLogic = `${Utils.N(perBL, curr)} Per Bill of Lading`;
            if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
            break;
          case "CH8":
            displayLogic = `${Utils.N(min, curr)} Minimum, ${Utils.N(perBL, curr)} Per Bill of Lading`;
            if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
            break;
          case "CH9":
            displayLogic = `${Utils.N(max, curr)} Maximum, ${Utils.N(perBL, curr)} Per Bill of Lading`;
            if (wmLogic) displayLogic = `${wmLogic}, ${displayLogic}`;
            break;
        }
        if (displayLogic.indexOf('Per Bill of Lading') == -1) {
          if (perBL != 0) {
            displayLogic += `, ${Utils.N(perBL, curr)} Per Bill of Lading`;
          }
        }

        return {
          chargeDescription: item.chargeDescription,
          remarks: item.remarks || "",
          CH,
          currency: curr,
          perCBM: cbm || null,
          perTon: ton || null,
          minimum: min || null,
          maximum: max || null,
          perBL: perBL || null,
          displayLogic,
        };
      });
    };

    let origincharges = [];
    let oceanFreightcharges = [];
    let Destinationcharges = [];
    let DestinationDescription = [];
    for (let i = 0; i < chargelist.length; i++) {
      let c = chargelist[i];
      if (c != undefined && c["chargeDescription"] != undefined) {
        let d = c["chargeDescription"];
        let cat = (c["category"] || "").toUpperCase();

        if (cat === "ORIGIN") {
          d = d.replace("Origin Charges - ", "");
          d = d.replace("Origin - ", "");
          d = d.replace("Origin Charges", "");
          d = d.replace("Origin", "");
          chargelist[i]["chargeDescription"] = d;
          origincharges.push(chargelist[i]);
        } else if (cat === "DESTINATION") {
          d = d.replace("Destination Charges - ", "");
          d = d.replace("Destination - ", "");
          d = d.replace("Destination Charges", "");
          d = d.replace("Destination", "");
          chargelist[i]["chargeDescription"] = d;
          if (d.length > 0) {
            DestinationDescription.push(d);
          }
          Destinationcharges.push(chargelist[i]);
        } else if (cat === "FREIGHT" || cat === "OCEAN FREIGHT") {
          oceanFreightcharges.push(chargelist[i]);
        }
      }
    }

    let Destinationchargestotal = {
      chargeDescription: "Destination",
      perCBM: 0,
      perTon: 0,
      minimum: 0,
      maximum: 0,
      perBL: 0,
      currency: "INR",
    };
    
    for (let i = 0; i < Destinationcharges.length; i++) {
      let d = Destinationcharges[i];
      Destinationchargestotal["currency"] = Destinationcharges[0]["currency"];
      let k = ["perCBM", "perTon", "minimum", "maximum", "perBL"];
      k.map((e) => {
        if (d[e] != undefined && d[e]) {
          Destinationchargestotal[e] = Destinationchargestotal[e] + Number(d[e]);
        }
      });
    }

    origincharges = convertCharges(origincharges);
    oceanFreightcharges = convertCharges(oceanFreightcharges);
    if (Destinationcharges.length > 0) {
      Destinationchargestotal = convertCharges([Destinationchargestotal]);
      Destinationcharges = convertCharges(Destinationcharges);
    }

    let lines = [];

    // Header
    lines.push("*OCEAN FREIGHT RATE*");
    lines.push(`📍 ${origin} → ${destination}`);
    lines.push(`🚢 Routing: ${routing}`);

    // Ocean Freight
    if (oceanFreightcharges.length > 0) {
      lines.push("");
      lines.push("*OCEAN FREIGHT*");
      oceanFreightcharges.forEach(e => {
        lines.push(`• ${e.chargeDescription}: ${e.displayLogic}`);
        if (e.remarks && String(e.remarks).trim()) {
          const rem = String(e.remarks).trim();
          lines.push(`_(${rem})_`);
        }
      });
    }

    if (!copiedOceanFreight) {
      // Origin Charges
      if (origincharges.length > 0) {
        lines.push("");
        lines.push("*ORIGIN CHARGES*");
        origincharges.forEach(e => {
          lines.push(`• ${e.chargeDescription}: ${e.displayLogic}`);
          if (e.remarks && String(e.remarks).trim()) {
            const rem = String(e.remarks).trim();
            lines.push(`_(${rem})_`);
          }
        });
      }

      // Destination Charges
      if (viewMode === "Detailed" && Destinationcharges.length > 0) {
        lines.push("");
        lines.push("*DESTINATION CHARGES*");
        Destinationcharges.forEach(e => {
          lines.push(`• ${e.chargeDescription}: ${e.displayLogic}`);
          if (e.remarks && String(e.remarks).trim()) {
            const rem = String(e.remarks).trim();
            lines.push(`_(${rem})_`);
          }
        });
      } else if (viewMode === "Summary" && Destinationcharges.length > 0) {
        lines.push("");
        lines.push("*DESTINATION CHARGES - SUMMARY*");
        if (Destinationchargestotal[0]?.displayLogic) {
          lines.push(`• Destination Charges Total: ${Destinationchargestotal[0].displayLogic}`);
        }
        if (DestinationDescription.length > 0) {
          lines.push(`  Inclusive of ${DestinationDescription.join(", ")}`);
        }
      }
    }

    // Agent Details
    if (agentDetails.length > 0 || agentAddress.length > 0) {
      lines.push("");
      lines.push("*AGENT DETAILS*");
      if (agentDetails.length > 0) {
        lines.push(`🏢 ${agentDetails}`);
      }
      if (agentAddress.length > 0) {
        const addrLines = agentAddress.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
        addrLines.forEach(l => {
          const isPhone = /^(\+?\d[\d\s\-\(\)]{5,}\d|phone|tel|mobile|fax)/i.test(l);
          if (isPhone) {
            lines.push(`📞 ${l}`);
          } else {
            lines.push(`📍 ${l}`);
          }
        });
      }
    }

    // Terms & Conditions
    const numEmojis = ['1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟'];
    if (!copiedOceanFreight && tc.length > 0) {
      lines.push("");
      lines.push("*TERMS & CONDITIONS*");
      tc.forEach((e, i) => {
        const prefix = numEmojis[i] || `${i + 1}.`;
        lines.push(`${prefix} ${e}`);
      });
    } else if (copiedOceanFreight) {
      lines.push("");
      lines.push("*TERMS & CONDITIONS*");
      lines.push("1️⃣ Destination Charges are at Actual.");
      lines.push("2️⃣ Destination CFS Charges are at actuals.");
    }

    return lines.join("\n");
  };

  const copyElement = () => {
    if (isMobile) {
      const mobileText = buildMobileCopyTextForRateRequest(prjs(editapprovalStore.quote), false, view);
      copyTextToClipboard(mobileText);
      if (copied == false) {
        setCopied(true);
      }
      return;
    }

    const el = copyRef.current;
    if (!el) return alert("Element not found");

    const range = document.createRange();
    range.selectNodeContents(el);

    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);

    document.execCommand("copy");
    sel.removeAllRanges();
    if (copied == false) {
      setCopied(true);
    }
  };

  const copyElement1 = () => {
    if (isMobile) {
      const mobileText = buildMobileCopyTextForRateRequest(prjs(editapprovalStore.quote), true, view);
      copyTextToClipboard(mobileText);
      if (copied1 == false) {
        setCopied1(true);
      }
      return;
    }

    const el = copyRef1.current;
    if (!el) return alert("Element not found");

    const range = document.createRange();
    range.selectNodeContents(el);

    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);

    document.execCommand("copy");
    sel.removeAllRanges();
    if (copied1 == false) {
      setCopied1(true);
    }
  };

  return (
    <>
      <Card rec={prjs(editapprovalStore.quote)} copiedOceanFreight={false} id={"1"} key={"1"} />
      <Card rec={prjs(editapprovalStore.quote)} copiedOceanFreight={true} id={"2"} key={"2"} />
      <br />

      <div className="columns is-vcentered is-multiline">
        <div className="column is-12" style={{ textAlign: "right" }}>
          <div
            className="field is-grouped"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <div className="control">
              <button
                className="button"
                style={{
                  backgroundColor:
                    process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                  color: "#fff",
                }}
                onClick={async (e) => {
                  copyElement();
                }}
              >
                {copied ? "Copied" : "Copy"}
              </button>
            </div>
            <div className="control">
              <button
                className="button"
                style={{
                  backgroundColor:
                    process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                  color: "#fff",
                }}
                onClick={async (e) => {
                  copyElement1();
                }}
              >
                {copied1 ? "Copied Ocean Freight" : "Copy Ocean Freight"}
              </button>
            </div>
            <div className="control">
              <button
                class="button is-danger"
                onClick={() => {
                  setOpenCopyMail(false);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
